// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3wdHm","tab":"ProcedureTabs_tab__3J46p"};